import { RootState } from '../../main/store/main.store.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

export const selectCurrentEnvironmentName = createMemoizedSelector(
  (state: RootState) => state.environment.selectedEnvironment,
  (selectedEnvironment): string => selectedEnvironment?.name ?? ''
);
